import { DefaultTheme } from '../../components/theme';

export const DEFAULT_COMPONENT_SPACING = 4;
export const DEFAULT_BACKGROUND = '#f0f0f0';

const pageSize = 'LETTER' as const;
const [pageWidth, pageHeight] = [612.0, 792.0];
export const pdfTheme = {
	background: {
		dark: DefaultTheme.background.darkGrey,
		medium: DefaultTheme.background.mediumGrey,
		light: DefaultTheme.background.fadedGrey,
		default: DEFAULT_BACKGROUND,
	},
	font: {
		color: {
			dark: DefaultTheme.font.color.primary,
			light: DefaultTheme.font.color.insight,
		},
		size: {
			default: 12,
			small: 10,
			large: 16,
		},
	},
	spacing: {
		large: 8,
		default: DEFAULT_COMPONENT_SPACING,
		small: 2,
	},
	page: {
		size: pageSize,
		width: pageWidth,
		height: pageHeight,
	},
};

// line height = font times 1.18 because ¯\_(ツ)_/¯
export const MAGIC_SCALING_NUMBER = 1.18;
